import React from "react";

import Link from "core/Link";

import { useLoginFlow } from "../Context";

const CodeRequestViewLink = ({ children }) => {
    const { goToCodeRequestView } = useLoginFlow();

    return (
        <Link
            isButton
            onClick={e => {
                e.preventDefault();
                goToCodeRequestView();
            }}
            data-testid="code-request-view-link"
        >
            {children}
        </Link>
    );
};

export default CodeRequestViewLink;
